import React, { useState, useEffect, useRef } from "react";
import { Card, Form, Row, Col, Button, Modal, Alert, Spinner } from "react-bootstrap";
import { Link, NavLink, useNavigate } from "react-router-dom";
import API, { base, base_new } from "api.js";
import SimpleReactValidator from "simple-react-validator";
import { setUser } from "action/index.js";
import { store, persistor } from "store/index";
import { useSelector, useDispatch } from "react-redux";
import PanelHeader from "components/PanelHeader/PanelHeader.jsx";
import { CountryRegionData } from "react-country-region-selector";
import Select from "react-select";
import DeleteUser from "components/Profile/DeleteUser";
import SidebarClose from "components/Sidebar/SidebarClose";
import { timeZonesNames, getTimeZones } from "@vvo/tzdb";
import DashboardHeader from "components/Dashboard/DashboardHeader/DashboardHeader";
import PhoneInputField from "components/Inputs/PhoneInputField";
import { isValidPhoneNumber } from "libphonenumber-js/mobile";
import useToast from "hooks/useToast";
import PlaceHolderUser from "assets/images/Useravatar.svg";
import AvailableBands from "data/availableBands.js";

const timezones = [
  { label: "Auto detect", value: "Auto detect" },
  ...timeZonesNames.map((timezone) => ({
    label: timezone,
    value: timezone,
  })),
];

function Mock() {
  const [data, setData] = useState([]);
  const [activeTab, setActiveTab] = useState(1);
  const [userName, setUserName] = useState("");
  const [first_name, setFirstName] = useState(null);
  const [last_name, setLastName] = useState(null);
  const [country_citizenship, setCountryCitizenship] = useState(null);
  const [country_residence, setCountryResidence] = useState(null);
  const [countryState, setCountryState] = useState("");
  const [dob, setDob] = useState(null);
  const [email, setEmail] = useState(null);
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState(null);
  const [lang, setLang] = useState("");
  const [center, setCenter] = useState(null);
  const [score, setScore] = useState(null);
  const [image, setImage] = useState("");
  const [image_src, setImageSrc] = useState("");
  const [imageTemp, setImageTemp] = useState("");
  const [error_bag, setErrorBag] = useState(null);
  const [modal, setModal] = useState(false);
  const [imgModal, setImgModal] = useState(false);
  const [selectArr, setSelectArr] = useState([]);
  const [subscriptionId, setSubscriptionId] = useState(null);
  const [name, setName] = useState("");
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [selectedCountryStates, setSelectedCountryStates] = useState([]);
  const [imageError, setImageError] = useState("");
  const [subscription, setSubscription] = useState(null);
  const [timezone, setTimezone] = useState("");
  const [imagePreview, setImagePreview] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [avatar, setAvatar] = useState(false);
  const [selectedAvatar, setSelectedAvatar] = useState(null);
  const [, setRender] = useState(false);
  const forceUpdate = () => setRender((prev) => !prev);
  const [isDialCodeSelected, setIsDialCodeSelected] = useState(null);
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const { showToast } = useToast();
  const user = useSelector((state) => state.user);
  const [selectedTimezone, setSelectedTimezone] = useState("Auto detect");
  const [showModal, setShowModal] = useState(false);
  const [saving, setSaving] = useState(false);


  const validator = useRef(
    new SimpleReactValidator({
      messages: {
        alpha_space: "Allowed only letters and spaces.",
      },
      validators: {
        firstnameMatch: {
          rule: (val) =>
            val !== null && val !== undefined && val.toString().trim() !== "",
          required: true,
          message: "First Name is required",
        },
        lastnameMatch: {
          rule: (val) =>
            val !== null && val !== undefined && val.toString().trim() !== "",
          required: true,
          message: "Last Name is required",
        },
        phoneMatch: {
          rule: (val) =>
            val !== null && val !== undefined && val.toString().trim() !== "",
          required: true,
          message: "Phone Number is required",
        },
        dialCodeRequired: {
          rule: () => false,
          message: "Please select a dial code",
        },
        phoneValid: {
          rule: (val) => {
            if (!val) return false;
            return isValidPhoneNumber(val);
          },
          required: true,
          message: "Please enter a valid phone number for the selected country",
        },
        countryMatch: {
          rule: (val) =>
            val !== null && val !== undefined && val.toString().trim() !== "",
          required: true,
          message: "Country is required",
        },
        stateMatch: {
          rule: (val) =>
            val !== null && val !== undefined && val.toString().trim() !== "",
          required: true,
          message: "State is required",
        },
        timezoneMatch: {
          rule: (val) =>
            val !== null && val !== undefined && val.toString().trim() !== "",
          required: true,
          message: "Timezone is required",
        },
      },
    })
  );

  const originalRef = useRef(null);

  useEffect(() => {
    if (isDialCodeSelected == false) {
      validator.current.showMessageFor("Enter Phone Number");
    }
  }, [isDialCodeSelected]);

  const changeInput = (e) => {
    const { name, value } = e.target;

    switch (name) {
      case "first_name":
        return setFirstName(value);
      case "last_name":
        return setLastName(value);
      case "email":
        return setEmail(value);
      case "address":
        return setAddress(value);
      case "dob":
        return setDob(value);
      case "lang":
        return setLang(value);
      case "phone":
        return setPhone(value);
      case "score":
        return setScore(value);
      case "center":
        return setCenter(value);
      default:
        console.warn("Unknown field", name);
    }
  };

  const getData = () => {
    API({
      method: "GET",
      url: "user-my-profile",
    })
      .then((data) => {
        const u = data.data.user;
        dispatch(setUser(u));
        const fname = u.first_name;
        const lname = u.last_name;
        const ct = u.country_citizenship;
        const cr = u.country_residence;
        const cs = u.country_state;
        const dobValue = u.dob;
        const mail = u.email;
        const ph = u.phone;
        const adr = u.address;
        const language = u.lang;
        const cntr = u.center;
        const sc = u.score;
        const imgSrc =
          u.image === null || u.image === "" ? user.image : u.image;

        const subs =
          u.active_subscription.length > 0 ? u.active_subscription[0] : null;

        const fullname = lname ? `${fname} ${lname}` : fname;

        let tz = "";
        if (u.user_timezone && u.user_timezone.timezone) {
          const saved = u.user_timezone.timezone;
          const canonical = getTimeZones().find(
            (t) => t.name === saved || (t.group && t.group.includes(saved))
          );
          tz = canonical ? canonical.name : "";
        }

        setName(fullname);
        setFirstName(fname);
        setLastName(lname);
        setCountryCitizenship(ct);
        setCountryResidence(cr);
        setCountryState(cs);
        setDob(dobValue);
        setEmail(mail);
        setPhone(ph);
        setAddress(adr);
        setLang(language);
        setCenter(cntr);
        setScore(sc);
        setImageSrc(imgSrc);
        setSubscription(subs);
        setTimezone(tz);

        if (
          imgSrc &&
          (imgSrc.includes("/storage/male.png") ||
            imgSrc.includes("/storage/female.png"))
        ) {
          setAvatar(true);
        }

        if (imgSrc.includes("/storage/female.png")) {
          setSelectedAvatar("/storage/female.png");
        } else if (imgSrc.includes("/storage/male.png")) {
          setSelectedAvatar("/storage/male.png");
        } else {
          setSelectedAvatar("image");
        }

        if (u.active_subscription[0]) {
          setSubscriptionId(u.active_subscription[0].stripe_subscription_id);
        }

        const selected = CountryRegionData.filter((value) => value[0] === cr);

        const statesString = selected[0][2];
        const statesArray = statesString
          .split("|")
          .map((state) => state.split("~")[0]);

        setStates(
          statesArray.map((value) => ({
            label: value,
            value: value,
          }))
        );
      })
      .catch(() => { });
  };

  useEffect(() => {
    let selectArrTemp = [];

    if (store.getState().is_main) {
      selectArrTemp = [
        "LA Parramatta Branch",
        "LA Sydney CBD Branch",
        "LA Jalandhar Branch",
        "LA Online Student",
        "LA Gurdaspur Branch",
        "LA Amritsar Branch",
        "LA Sirsa Branch",
        "LA Sri Ganganagar Branch",
        "LA Kurukshetra Branch",
        "LA Barnala Branch",
        "LA Butwal (Nepal)",
        "Not a student with LA",
      ];
    } else {
      selectArrTemp = ["Not a student with LA"];
    }

    setSelectArr(selectArrTemp);

    getData();

    const countriesArrTemp = CountryRegionData.map((value) => ({
      label: value[0],
      value: value,
    }));

    countriesArrTemp.sort(compareCountries);

    setCountries(countriesArrTemp);
  }, []);

  const compareCountries = (a, b) => {
    const topCountries = ["India", "Australia", "Pakistan"];
    const aIndex = topCountries.indexOf(a.label);
    const bIndex = topCountries.indexOf(b.label);

    if (aIndex !== -1 && bIndex !== -1) {
      return aIndex - bIndex;
    }
    if (aIndex !== -1) {
      return -1;
    }
    if (bIndex !== -1) {
      return 1;
    }
    return 0;
  };

  const selectCountry = (val) => {
    setCountryCitizenship(val);
  };

  const selectCountryResidence = (selectedLabel) => {
    const selectedCountry = countries.find((c) => c.label === selectedLabel);

    if (!selectedCountry) return;

    setCountryResidence(selectedCountry.label);
    setCountryState("");

    const statesString = selectedCountry.value[2];

    const statesArray = statesString
      .split("|")
      .map((state) => state.split("~")[0]);

    const statesMapped = statesArray.map((value) => ({
      label: value,
      value: value,
    }));

    setStates(statesMapped);
  };

  const selectRegion = (value) => {
    setCountryState(value);
  };

  const selectTimezone = (value) => {
    setTimezone(value);
  };

  const selectAvatar = async (av) => {
    setImageError("");
    const bodyFormData = new FormData();
    bodyFormData.append("email", email);

    // if (av && typeof av === "object") {
    //   bodyFormData.append("image", av);
    // } else {
    bodyFormData.append("avatarImage", av);
    // }

    let res = null;

    try {
      res = await API({
        method: "POST",
        url: "/saveUser",
        data: bodyFormData,
      });
    } catch (error) {
      setError({ error });
      return;
    }

    if (res.status === 200) {
      dispatch(setUser(res.data.response.user));
      showToast({
        message: res.data.response.message,
        type: 1,
      });

      setAvatar(true);
      setEditMode(false);
      setImgModal(!imgModal);
      setImageTemp("");
      getData();
      // window.location.reload();
    } else if (res.response?.status === 422) {
      setError(res.response);

      let str = "";

      Object.values(res.response.data.errors).forEach((val) => {
        str += val[0] + "\n";
      });

      setErrorBag(str);
    }
  };

  const postSignUp = async (e) => {
    if (!validator.current.allValid()) {
      validator.current.showMessages();
      forceUpdate();
      return false;
    }

    setErrorBag(null);

    e.preventDefault();

    var bodyFormData = new FormData();
    bodyFormData.append("phone", phone);
    bodyFormData.append("first_name", first_name);
    bodyFormData.append("last_name", last_name);

    if (dob !== null) {
      bodyFormData.append("dob", dob);
    }

    bodyFormData.append("score", score);
    bodyFormData.append("lang", lang);

    let tz =
      timezone === "Auto detect"
        ? getTimeZones().find(tz =>
          tz.group.includes(Intl.DateTimeFormat().resolvedOptions().timeZone)
        )?.name
        : timezone;

    bodyFormData.append("timezone", tz);
    bodyFormData.append("email", email);

    if (image) {
      bodyFormData.append("image", image);
    }

    bodyFormData.append("country_citizenship", country_residence);
    bodyFormData.append("country_residence", country_residence);
    bodyFormData.append("country_state", countryState);
    bodyFormData.append("center", center);

    let res = null;

    try {
      setSaving(true);
      res = await API({
        method: "POST",
        url: "/saveUser",
        data: bodyFormData,
      });
    } catch (error) {
      setErrorBag(error);
      setSaving(false);
      showToast({
        message: error?.response?.data?.message,
        type: 2,
      });
      return;
    }

    if (!res) {
      setSaving(false);
      return;
    }

    if (res.status === 200) {
      dispatch(setUser(res.data.response.user));

      showToast({
        message: res.data.response.message,
        type: 1,
      });

      // window.location.href = "/admin/dashboard";
      setEditMode(false);
      getData();
      setSaving(false);
    } else if (res.response.status === 422) {
      let str = "";
      Object.values(res.response.data.errors).forEach((val) => {
        str += val[0] + "\n";
      });

      setErrorBag(str);
      setSaving(false);
    }
  };

  const onImageChange = (event) => {
    if (event.target.files && event.target.files[0]) {
      let img = event.target.files[0];
      const allowedTypes = ["image/jpeg", "image/png", "image/gif"];
      if (!allowedTypes.includes(img.type)) {
        setImageError("Unsupported file type. Please upload a valid image.");
        event.target.value = null;
        return;
      }

      const maxSize = 2 * 1024 * 1024;
      if (img.size > maxSize) {
        setImageError("File size exceeds the limit (2MB).");
        event.target.value = null;
        return;
      }

      setImage(img);
      setImageError("");
      const imgURL = URL.createObjectURL(img);
      setImagePreview(imgURL);
    }
  };

  const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  const cancelSub = () => {
    navigate("/admin/subscription-detail");
  };

  const openModal = () => {
    setImageError("");
    setImgModal(!imgModal);
  };

  const cancelSubAction = (t) => {
    if (t) cancelSubApi();
    setModal(false);
  };

  const cancelSubApi = () => {
    var bodyFormData = new FormData();

    bodyFormData.set("user_id", dob);
    bodyFormData.set("stripe_subscription_id", subscriptionId);

    API({
      method: "POST",
      url: "cancel/sub",
      data: bodyFormData,
    })
      .then((data) => {
        if ("status" in data) {
          dispatch(setUser(data.data.user));

          showToast({
            message: data.data.message,
            type: 1,
          });
        } else {
          showToast({
            message: "Something went wrong",
            type: 2,
          });
        }
      })
      .catch(() => {
        showToast({
          message: "Something went wrong",
          type: 2,
        });
      });
  };

  const handlePhoneChange = (value) => {
    setPhone(value);
  };

  const handleImageClick = () => {
    setImageTemp(imagePreview);
    setImgModal(!imgModal);
  };

  const startEdit = () => {
    originalRef.current = {
      first_name,
      last_name,
      country_citizenship,
      country_residence,
      countryState,
      dob,
      email,
      phone,
      address,
      lang,
      center,
      score,
      timezone,
      image,
      imagePreview,
      selectedAvatar,
      avatar,
      imageTemp,
    };
    setEditMode(true);
  };

  const handleDiscard = () => {
    const orig = originalRef.current;
    if (orig) {
      setFirstName(orig.first_name);
      setLastName(orig.last_name);
      setCountryCitizenship(orig.country_citizenship);
      setCountryResidence(orig.country_residence);
      setCountryState(orig.countryState);
      setDob(orig.dob);
      setEmail(orig.email);
      setPhone(orig.phone);
      setAddress(orig.address);
      setLang(orig.lang);
      setCenter(orig.center);
      setScore(orig.score);
      setTimezone(orig.timezone);
      setImage(orig.image);
      setImagePreview(orig.imagePreview);
      setSelectedAvatar(orig.selectedAvatar);
      setAvatar(orig.avatar);
      setImageTemp(orig.imageTemp);
    } else {
      getData();
    }
    validator.current.hideMessages();
    forceUpdate();
    setEditMode(false);
  };

  const updateUser = () => {
    dispatch(
      setUser({
        ...user,
        timezone: selectedTimezone,
      })
    );
    setShowModal(true);
  };

  const showSubBtn = subscription && subscription.is_recurring_plan !== 0;

  const detectedTimezone =
    timezone === "Auto detect"
      ? getTimeZones().find(tz =>
          tz.group.includes(Intl.DateTimeFormat().resolvedOptions().timeZone)
        )?.name
      : timezone;
  const imageSrc = imageTemp ||
    (avatar && image_src ? base_new + image_src : null) ||
    (image_src ? base + image_src : null) ||
    PlaceHolderUser;
  return (
    <>
      {modal && (
        <Modal show={modal} size="sm" onHide={() => setModal(false)}>
          <Modal.Body>
            <div>Do you want to cancel subscription ?</div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="modalCloseBtn"
              onClick={() => cancelSubAction(1)}
            >
              Yes
            </Button>

            <Button
              variant="secondary"
              className="modalCloseBtn"
              onClick={() => cancelSubAction(0)}
            >
              No
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      {imgModal && (
        <Modal show={imgModal} onHide={openModal}>
          <Modal.Header className="d-flex">
            <Modal.Title className="text-translation popup_heading m-0">
              Please Select the Avatar or Image.
            </Modal.Title>

            <Button
              variant="link"
              className="modalClose-Btn p-0"
              onClick={openModal}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                width="24"
                height="24"
              >
                <path
                  d="M18 6L6 18M6 6l12 12"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Button>
          </Modal.Header>

          <Modal.Body>
            <div className="row">
              <div className="col-md-4 text-center">
                <img
                  style={{ width: "100px" }}
                  src="/images/female.png"
                  alt="Female"
                  className={
                    selectedAvatar === "/storage/female.png"
                      ? "avatar-selected"
                      : ""
                  }
                  onClick={() => setSelectedAvatar("/storage/female.png")}
                />
                <div>
                  <span
                    onClick={() => selectAvatar("/storage/female.png")}
                    className="mt-3 btn btn-success"
                  >
                    Select
                  </span>
                </div>
              </div>

              <div className="col-md-4 text-center">
                <img
                  style={{ width: "100px" }}
                  src="/images/male.png"
                  alt="Male"
                  className={
                    selectedAvatar === "/storage/male.png"
                      ? "avatar-selected"
                      : ""
                  }
                  onClick={() => setSelectedAvatar("/storage/male.png")}
                />
                <div>
                  <span
                    onClick={() => selectAvatar("/storage/male.png")}
                    className="mt-3 btn btn-success"
                  >
                    Select
                  </span>
                </div>
              </div>
              <div className="col-md-4 text-center">
                <label
                  htmlFor="uploadAvatar"
                  className={`upload-oval-box ${selectedAvatar === "image" ? "avatar-selected" : ""
                    }`}
                  onClick={() => {
                    setSelectedAvatar("image");
                  }}
                >
                  {imagePreview ? (
                    <img
                      src={imagePreview}
                      alt="Preview"
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        borderRadius: "50%",
                      }}
                    />
                  ) : (
                    <span>Select Image</span>
                  )}
                </label>

                <input
                  id="uploadAvatar"
                  type="file"
                  className="d-none"
                  onChange={onImageChange}
                />

                <div>
                  <span
                    onClick={handleImageClick}
                    className="mt-3 btn btn-success"
                  >
                    Select
                  </span>
                </div>
                {imageError && (
                  <small style={{ color: "red" }}>{imageError}</small>
                )}
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              className="modalCloseBtn"
              onClick={openModal}
            >
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      <div className="content p-0 w-100">
        <DashboardHeader title="My Profile" avatar={avatar} />
        <div className="contact-page outer-wrapper">
          <Col className="profile-content p-0 d-flex align-items-center" md={12} sm={12}>
            <Form.Group>
              <div className="profile-img-wrapper">
                <div className="scoreUserImg">
                  <div className="scoreImgOuter">
                    <img
                      onClick={() => editMode && openModal()}
                      src={imageSrc}
                      onError={(e) => {
                        e.target.src = PlaceHolderUser;
                      }}
                      alt="Avatar"
                      style={{ pointerEvents: !editMode ? "none" : "auto" }}
                    />
                    {/* THis is the image editor icon */}
                    {editMode && (
                      <button
                        type="button"
                        aria-label="Edit profile picture"
                        onClick={openModal}
                        style={{
                          //button coming on top of desired score dropdown hence reduced z index 
                          zIndex: "1",
                          position: "absolute",
                          bottom: "0",
                          right: "0",
                          background: "#fff",
                          borderRadius: "50%",
                          padding: "4px",
                          boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                          border: "none",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center"
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="16"
                          height="16"
                          viewBox="0 0 576 512"
                          aria-hidden="true"
                        >
                          <path d="M402.6 83.2l90.2 90.2c3.8 3.8 3.8 10 0 13.8L274.4 405.6l-92.8 10.3c-12.4 1.4-22.9-9.1-21.5-21.5l10.3-92.8L388.8 83.2c3.8-3.8 10-3.8 13.8 0zm162-22.9l-48.8-48.8c-15.2-15.2-39.9-15.2-55.2 0l-35.4 35.4c-3.8 3.8-3.8 10 0 13.8l90.2 90.2c3.8 3.8 10 3.8 13.8 0l35.4-35.4c15.2-15.3 15.2-40 0-55.2zM384 346.2V448H64V128h229.8c3.2 0 6.2-1.3 8.5-3.5l40-40c7.6-7.6 2.2-20.5-8.5-20.5H48C21.5 64 0 85.5 0 112v352c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V306.2c0-10.7-12.9-16-20.5-8.5l-40 40c-2.2 2.3-3.5 5.3-3.5 8.5z" />
                        </svg>
                      </button>
                    )}
                  </div>
                </div>

                {/* <div className="profile-edit-btn">
                  <Form.Control
                    defaultValue={image}
                    name="image"
                    type="file"
                    className="form-control"
                    onChange={onImageChange}
                  />

                  <div className="edit-img">
                    <img src={EditImg} alt="edit-icon" />
                  </div>
                </div> */}
              </div>

              {imageError && (
                <small style={{ color: "red" }}>{imageError}</small>
              )}
            </Form.Group>
            <div>
              <p className="m-0 fw-bold">{user?.first_name} {user?.last_name} </p>
              <p className="m-0 small">{user?.email}</p>
            </div>
          </Col>
          <Form className="contact-form" id="profile-form">
            <Row>
              <Col md={6} sm={12}>
                <Form.Group>
                  <Form.Label>First Name*</Form.Label>
                  <Form.Control
                    type="text"
                    name="first_name"
                    placeholder="First Name"
                    value={first_name}
                    onChange={changeInput}
                    disabled={!editMode}
                  />
                  {validator.current.message(
                    "first name",
                    first_name,
                    "firstnameMatch|alpha_space|max:15"
                  )}
                </Form.Group>
              </Col>

              <Col md={6} sm={12}>
                <Form.Group>
                  <Form.Label>Last Name*</Form.Label>
                  <Form.Control
                    type="text"
                    name="last_name"
                    placeholder="Last Name"
                    value={last_name}
                    onChange={changeInput}
                    disabled={!editMode}
                  />
                  {validator.current.message(
                    "last name",
                    last_name,
                    "lastnameMatch|alpha_space|max:15"
                  )}
                </Form.Group>
              </Col>

              <Col md={6} sm={12}>
                <Form.Group>
                  <Form.Label>Phone*</Form.Label>
                  <div className="contact-input-wrapper">
                    <PhoneInputField
                      value={phone}
                      changeEvent={handlePhoneChange}
                      addClass="popup-class phone-profile"
                      onDialCodeStatusChange={(status) =>
                        setIsDialCodeSelected(status)
                      }
                      disabled={!editMode}
                      dialCodeDisabled={!editMode}
                    />
                  </div>
                  {phone === ""
                    ? validator.current.message(
                      "Enter Phone Number",
                      phone,
                      "phoneMatch"
                    )
                    : !isDialCodeSelected
                      ? validator.current.message(
                        "Enter Phone Number",
                        phone,
                        "dialCodeRequired"
                      )
                      : validator.current.message(
                        "Enter Phone Number",
                        phone,
                        "phoneValid"
                      )}
                </Form.Group>
              </Col>

              {/* <Col md={6} sm={12}>
                <Form.Group>
                  <Form.Label>Country of residence*</Form.Label>
                  <Select
                    placeholder="Select Country"
                    value={countries.find((option) => option.label === country_residence) || null}
                    isSearchable={true}
                    isDisabled={!editMode}
                    name="country_residence"
                    options={countries}
                    menuPlacement="auto"
                    menuPortalTarget={document.body}
                    styles={{
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999,
                      }),
                      menu: (base) => ({
                        ...base,
                        maxHeight: 150,
                      }),
                      menuList: (base) => ({
                        ...base,
                        maxHeight: 150,
                        overflowY: "auto",
                      }),
                    }}
                    onChange={(val) => selectCountryResidence(val.label)}
                  />
                  {validator.current.message(
                    "country of residence",
                    country_residence,
                    "countryMatch"
                  )}
                </Form.Group>
              </Col> */}
              <Col md={6} sm={12}>
                <Form.Group>
                  <Form.Label>Default Language</Form.Label>
                  <div className="select-wrapper">
                    <Select
                      placeholder="Select Language"
                      value={lang ? { label: lang, value: lang } : null}
                      isSearchable={false}
                      isDisabled={!editMode}
                      name="lang"
                      options={[
                        { label: "en-GB", value: "en-GB" },
                        { label: "en-US", value: "en-US" },
                      ]}
                      menuPlacement="auto"
                      styles={{
                        menu: (base) => ({
                          ...base,
                          maxHeight: 300,
                        }),
                        menuList: (base) => ({
                          ...base,
                          maxHeight: 300,
                          overflowY: "auto",
                        }),
                      }}
                      onChange={(val) => setLang(val.value)}
                    />
                  </div>
                </Form.Group>
              </Col>

              <Col md={6} sm={12}>
                <Form.Group>
                  <Form.Label>Desired score</Form.Label>
                  <div className="select-wrapper">
                    <Select
                      placeholder="Select desired score"
                      value={
                        score && score !== "null"
                          ? AvailableBands.find(band => band.value === String(score)) || { label: `${score}+`, value: score }
                          : null
                      }
                      isSearchable={false}
                      isDisabled={!editMode}
                      name="score"
                      options={AvailableBands.filter(band => band.value !== "0")}
                      menuPlacement="auto"
                      styles={{
                        menu: (base) => ({
                          ...base,
                          maxHeight: 300,
                        }),
                        menuList: (base) => ({
                          ...base,
                          maxHeight: 300,
                          overflowY: "auto",
                        }),
                      }}
                      onChange={(val) => setScore(val.value)}
                    />
                  </div>
                </Form.Group>
              </Col>

              <Col md={6} sm={12}>
                <Form.Group>
                  <Form.Label>Timezone*</Form.Label>
                  <Select
                    placeholder="Search Timezone"
                    value={timezones.find((tz) => tz.value === timezone) || null}
                    isSearchable={true}
                    name="timezone"
                    options={timezones}
                    menuPlacement="auto"
                    menuPortalTarget={document.body}
                    components={{
                      Input: ({ innerRef, isDisabled, isHidden, cx, getValue, selectProps, clearValue, hasValue, isMulti, isRtl, options, selectOption, setValue, theme, getStyles, getClassNames, ...innerProps }) => (
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "1fr",
                            width: "100%",
                            gridArea: "1 / 1 / 2 / 3",
                          }}
                          data-value={innerProps.value || ""}
                        >
                          <input
                            ref={innerRef}
                            disabled={isDisabled}
                            style={{
                              gridArea: "1 / 1",
                              width: "100%",
                              background: 0,
                              opacity: isHidden ? 0 : 1,
                              color: "inherit",
                              font: "inherit",
                              minWidth: "2px",
                              border: 0,
                              margin: 0,
                              outline: 0,
                              padding: 0,
                            }}
                            {...innerProps}
                          />
                        </div>
                      ),
                    }}
                    styles={{
                      menuPortal: (base) => ({
                        ...base,
                        zIndex: 9999,
                      }),
                      menu: (base) => ({
                        ...base,
                        maxHeight: 300,
                      }),
                      menuList: (base) => ({
                        ...base,
                        maxHeight: 300,
                        overflowY: "auto",
                      }),
                      control: (base) => ({
                        ...base,
                        display: "flex",
                        height: "auto",
                        minHeight: 40,
                      }),
                      valueContainer: (base) => ({
                        ...base,
                        display: "grid",
                        gridTemplateColumns: "1fr",
                        overflow: "visible",
                      }),
                      singleValue: (base) => ({
                        ...base,
                        gridArea: "1 / 1 / 2 / 3",
                      }),
                    }}
                    onChange={(val) => selectTimezone(val.value)}
                    isDisabled={!editMode}
                  />
                  {validator.current.message(
                    "timezone",
                    timezone,
                    "required|timezoneMatch",
                    { messages: { required: "Timezone is required" } }
                  )}
                </Form.Group>
              </Col>
            </Row>

            {/* <Row>
              <Col md={6} sm={12}>
                <Form.Group>
                  <Form.Label>Email</Form.Label>
                  <Form.Control
                    type="text"
                    value={email || ""}
                    disabled={true}
                  />
                </Form.Group>
              </Col>
            </Row> */}
          </Form>

          <Row className="contact-form-btns">
            {!editMode && (
              <Col
                className="d-flex justify-content-center gap-3 text-md-right mt-3"
                md={12}
                sm={12}

              >
                <Button
                  className="btn-round contact-save-btn"
                  variant="info"
                  onClick={startEdit}
                >
                  Edit Profile
                </Button>

                <Button
                  className="btn-round contact-save-btn"
                  variant="info"
                  onClick={() => navigate("/admin/password")}
                >
                  Change Password
                </Button>
              </Col>
            )}
            {editMode && (
              <>
                <Col
                  className="d-flex flex-wrap align-items-center mt-3"
                  md={6}
                  sm={12}
                >
                  <DeleteUser />
                  {/* 
                  <Link to="/admin/password" className="change-password">
                    <i className="fa fa-key" aria-hidden="true"></i>
                    Change Password
                  </Link> */}
                </Col>

                <Col className="text-md-right mt-3" md={6} sm={12}>
                  <Button
                    className="btn-round contact-discard-btn"
                    variant="info"
                    onClick={handleDiscard}
                    disabled={saving}
                  >
                    Discard
                  </Button>

                  <Button
                    className="btn-round contact-save-btn"
                    variant="info"
                    onClick={postSignUp}
                    disabled={saving}
                  >
                    {saving ? (
                      <>
                        <Spinner animation="border" size="sm" className="me-2" />
                        Saving...
                      </>
                    ) : (
                      "Save Changes"
                    )}
                  </Button>
                </Col>
              </>
            )}
          </Row>
        </div>
      </div>
    </>
  );
}

export default Mock;
